import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../stores/store";
// import { useTranslation } from "react-i18next";
const NotFound = () => {
  const { mainStore } = useStore();
  const navigate = useNavigate();
  // const { t } = useTranslation();
  useEffect(() => {
    //mainStore.setMenuType(-1);
    mainStore.setMenuNo(-1);
    // eslint-disable-next-line
  }, [mainStore]);
  
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/Profile');
    }
  };
  
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <div className="text-center">
        <i className="bi bi-exclamation-triangle-fill text-danger" style={{ fontSize: '4rem' }}></i>
        <h1 className="text-danger mt-3" style={{ fontSize: '2.5rem', fontWeight: '600' }}>404</h1>
        <h4 className="text-muted" style={{ fontSize: '1.1rem' }}>Page Not Found</h4>
        <p className="text-muted mt-2" style={{ fontSize: '0.9rem' }}>
          The page you are looking for doesn't exist.
        </p>
        <button onClick={handleGoBack} className="btn btn-danger mt-3">
          <i className="bi bi-arrow-left-circle-fill me-2"></i>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
